import { SchemeTypes } from 'config';
import { LanguagesEnum } from '../../../../../../config/languages';

const CONFIGURATION = {};

export const Translations = {
  fixed_establishment_control: {
    [LanguagesEnum.English]: 'Fixed Establishment',
    [LanguagesEnum.Greek]: 'Fixed Establishment',
  },
  vat_number_control: {
    [LanguagesEnum.English]: 'VAT Number (MSEST)',
    [LanguagesEnum.Greek]: 'VAT Number (MSEST)',
  },
  type_of_supply_control: {
    [LanguagesEnum.English]: 'Type of Supply',
    [LanguagesEnum.Greek]: 'Type of Supply',
  },
  consumer_country_control: {
    [LanguagesEnum.English]: 'Consumer Country',
    [LanguagesEnum.Greek]: 'Consumer Country',
  },
  vat_rate_type_control: {
    [LanguagesEnum.English]: 'VAT Rate/Type',
    [LanguagesEnum.Greek]: 'VAT Rate/Type',
  },
  taxable_amount_control: {
    [LanguagesEnum.English]: 'Taxable Amount (€)',
    [LanguagesEnum.Greek]: 'Taxable Amount (€)',
  },
  cents_control: {
    [LanguagesEnum.English]: 'Cents',
    [LanguagesEnum.Greek]: 'Cents',
  },
  form_error_required: {
    [LanguagesEnum.English]: 'This is required',
    [LanguagesEnum.Greek]: 'Υποχρεωτικό πεδίο',
  },
  add_supply: {
    [LanguagesEnum.English]: 'Add Supply',
    [LanguagesEnum.Greek]: 'Add Supply',
  },
  negative_cents_error: {
    [LanguagesEnum.Greek]: 'Valid: 0-99',
    [LanguagesEnum.English]: 'Valid: 0-99',
  },
  invalid_cents_error: {
    [LanguagesEnum.Greek]: '1-2 digits',
    [LanguagesEnum.English]: '1-2 digits',
  },
  invalid_amount_cents_error: {
    [LanguagesEnum.Greek]: 'Valid: 0-99',
    [LanguagesEnum.English]: 'Valid: 0-99',
  },
};

export default CONFIGURATION;

// --EU scheme ,Goods Services
// --Non Eu   , Services
// --Import Scheme  , Goods

export const getSupplyTypes = (schemeType: number, notEstablished: boolean) => {
  switch (schemeType) {
    case SchemeTypes.EU:
      if (notEstablished === true) {
        return [
          {
            id: '1',
            label: 'GOODS',
          },
        ];
      } else {
        return [
          {
            id: '1',
            label: 'GOODS',
          },
          {
            id: '2',
            label: 'SERVICES',
          },
        ];
      }
    case SchemeTypes.NON_EU:
      return [
        {
          id: '2',
          label: 'SERVICES',
        },
      ];
    case SchemeTypes.IOSS:
      return [
        {
          id: '1',
          label: 'GOODS',
        },
      ];
    default:
      return [];
  }
};
